import { render, staticRenderFns } from "./AssignToRoleComponent.vue?vue&type=template&id=71ac591e&scoped=true&"
import script from "./AssignToRoleComponent.vue?vue&type=script&lang=js&"
export * from "./AssignToRoleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ac591e",
  null
  
)

export default component.exports